function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.292 0.293824C21.9014 -0.0967003 21.2683 -0.0967002 20.8777 0.293824L12 9.17156L3.1223 0.29384C2.73178 -0.096684 2.09861 -0.096684 1.70809 0.29384L0.293873 1.70805C-0.0966514 2.09858 -0.0966513 2.73174 0.293873 3.12227L9.17159 12L0.29387 20.8777C-0.0966545 21.2682 -0.0966545 21.9014 0.29387 22.2919L1.70808 23.7061C2.09861 24.0967 2.73177 24.0967 3.1223 23.7061L12 14.8284L20.8778 23.7061C21.2683 24.0967 21.9014 24.0967 22.292 23.7061L23.7062 22.2919C24.0967 21.9014 24.0967 21.2682 23.7062 20.8777L14.8284 12L23.7062 3.12225C24.0967 2.73173 24.0967 2.09856 23.7062 1.70804L22.292 0.293824Z",
  fill: "#004152"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.f7821840.svg";
export { ForwardRef as ReactComponent };